import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";

export default function Collections() {
  const [c, setC] = useState([]);
  useEffect(() => { api.get("/collections").then((r) => setC(r.data)); }, []);
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16">
      <div className="text-center mb-12">
        <p className="font-caption text-brass text-xs mb-2">Wander</p>
        <h1 className="font-display text-4xl sm:text-6xl text-gold">Collections</h1>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
        {c.map((col) => (
          <Link key={col.id} to={`/shop?collection=${col.slug}`} className="curio-card corner-frame p-10 text-center block">
            <div className="font-display text-3xl text-gold mb-3">{col.name}</div>
            <p className="text-parchment/70 italic">{col.description}</p>
            <div className="font-caption text-brass text-[10px] mt-6">Enter →</div>
          </Link>
        ))}
      </div>
    </div>
  );
}
